import { createSelector } from "reselect";

const selectExam = (state) => state.exam;

export const selectExamLoading = createSelector(
  [selectExam],
  (exam) => exam.isLoading
);

export const selectSingleExamLoading = createSelector(
  [selectExam],
  (exam) => exam.isLoadingExam
);

export const selectExamList = createSelector(
  [selectExam],
  (exam) => exam.exams
);

export const selectOneExam = createSelector([selectExam], (exam) => exam.exam);

export const selectIsCreatingExam = createSelector(
  [selectExam],
  (exam) => exam.isCreatingExam
);

export const selectIsEditingExam = createSelector(
  [selectExam],
  (exam) => exam.isEditingExam
);

export const selectCurrentExam = createSelector(
  [selectExam],
  (exam) => exam.currentExam
);
